import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const submitForm = async (path, data) => {
  if (!BASE) throw new Error("Form service unavailable");
  const res = await axios.post(`${BASE}/api/${path}`, data);
  return res?.data ?? {};
};

export const errorMessage = (err) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Please check the highlighted fields and try again.";
  return "Something went wrong. Please try again or call us.";
};
